import {
  DiscountCodeSchema
} from "../chunk-B3COBENK.js";

// discount-code-redemptions/discount-code-redemptions.schema.ts
import { z } from "zod";
var DiscountCodeRedemptionSchema = z.object({
  id: z.string().uuid(),
  discountCodeId: z.string().uuid(),
  customerId: z.number().int().positive(),
  orderId: z.number().int().positive().nullable(),
  discountAmount: z.string(),
  orderTotal: z.string(),
  redeemedAt: z.coerce.date(),
  hostDomain: z.string().min(1).max(255)
});
var DiscountCodeRedemptionWithCodeSchema = DiscountCodeRedemptionSchema.extend({
  discountCode: DiscountCodeSchema
});
var CreateDiscountCodeRedemptionDtoSchema = z.object({
  discountCodeId: z.string().uuid(),
  customerId: z.number().int().positive(),
  orderId: z.number().int().positive().optional(),
  discountAmount: z.string(),
  orderTotal: z.string(),
  hostDomain: z.string().min(1).max(255)
});
var FindDiscountCodeRedemptionsDtoSchema = z.object({
  discountCodeId: z.string().uuid().optional(),
  customerId: z.number().int().positive().optional(),
  orderId: z.number().int().positive().optional(),
  hostDomain: z.string().optional(),
  redeemedAfter: z.coerce.date().optional(),
  redeemedBefore: z.coerce.date().optional(),
  limit: z.number().int().positive().optional(),
  offset: z.number().int().min(0).optional()
});
var DiscountCodeRedemptionResponseDtoSchema = z.object({
  id: z.string().uuid(),
  discountCodeId: z.string().uuid(),
  customerId: z.number().int().positive(),
  orderId: z.number().int().positive().nullable(),
  discountAmount: z.string(),
  orderTotal: z.string(),
  redeemedAt: z.string(),
  hostDomain: z.string()
});
var DiscountCodeRedemptionWithCodeResponseDtoSchema = DiscountCodeRedemptionResponseDtoSchema.extend({
  discountCode: z.object({
    code: z.string(),
    discountType: z.string(),
    discountValue: z.string()
  })
});
var GetRedemptionStatsDtoSchema = z.object({
  hostDomain: z.string().optional(),
  discountCodeId: z.string().uuid().optional(),
  startDate: z.coerce.date().optional(),
  endDate: z.coerce.date().optional()
});
var RedemptionStatsResponseDtoSchema = z.object({
  totalRedemptions: z.number().int().min(0),
  totalDiscountAmount: z.string(),
  averageDiscountAmount: z.string(),
  averageOrderTotal: z.string(),
  uniqueCustomers: z.number().int().min(0),
  topDiscountCodes: z.array(
    z.object({
      code: z.string(),
      redemptions: z.number().int().min(0),
      totalDiscountAmount: z.string()
    })
  ),
  recentRedemptions: z.number().int().min(0)
});
var GetCustomerRedemptionsDtoSchema = z.object({
  customerId: z.number().int().positive(),
  hostDomain: z.string().min(1).max(255),
  limit: z.number().int().positive().optional(),
  offset: z.number().int().min(0).optional()
});
var CheckCustomerEligibilityDtoSchema = z.object({
  customerId: z.number().int().positive(),
  discountCodeId: z.string().uuid(),
  hostDomain: z.string().min(1).max(255)
});
var CustomerEligibilityResponseDtoSchema = z.object({
  isEligible: z.boolean(),
  reason: z.string().optional(),
  currentUses: z.number().int().min(0),
  maxUsesPerCustomer: z.number().int().positive()
});
var DiscountCodeRedemptionQueryFiltersSchema = z.object({
  discountCodeId: z.string().uuid().optional(),
  customerId: z.number().int().positive().optional(),
  orderId: z.number().int().positive().optional(),
  hostDomain: z.string().optional(),
  redeemedAfter: z.coerce.date().optional(),
  redeemedBefore: z.coerce.date().optional()
});
var DiscountCodeRedemptionStatsSchema = z.object({
  totalRedemptions: z.number().int().min(0),
  totalDiscountAmount: z.string(),
  averageDiscountAmount: z.string(),
  averageOrderTotal: z.string(),
  uniqueCustomers: z.number().int().min(0),
  topDiscountCodes: z.array(
    z.object({
      code: z.string(),
      redemptions: z.number().int().min(0),
      totalDiscountAmount: z.string()
    })
  ),
  recentRedemptions: z.number().int().min(0)
});
var RedemptionsByPeriodSchema = z.object({
  period: z.string(),
  count: z.number().int().min(0),
  totalDiscountAmount: z.string(),
  averageOrderTotal: z.string()
});
export {
  CheckCustomerEligibilityDtoSchema,
  CreateDiscountCodeRedemptionDtoSchema,
  CustomerEligibilityResponseDtoSchema,
  DiscountCodeRedemptionQueryFiltersSchema,
  DiscountCodeRedemptionResponseDtoSchema,
  DiscountCodeRedemptionSchema,
  DiscountCodeRedemptionStatsSchema,
  DiscountCodeRedemptionWithCodeResponseDtoSchema,
  DiscountCodeRedemptionWithCodeSchema,
  FindDiscountCodeRedemptionsDtoSchema,
  GetCustomerRedemptionsDtoSchema,
  GetRedemptionStatsDtoSchema,
  RedemptionStatsResponseDtoSchema,
  RedemptionsByPeriodSchema
};
